<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('ratecard') }}</div>
      <div>
        <a
          class="btn-blue"
          @click.prevent.stop="goToRoute('/cinema-manager/edit-rate-card',{ rc_id: tableId })"
        >{{ $t('edit') }}</a>
        <router-link class="btn-blue" to="rateCard">{{ $t('ratecard') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">Rate Card Name</div>
              <div class="col-md-3 col-lg-2 col-xl-2">{{ ratecard.rc_name }}</div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('ratecard') }} {{ $t('description') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">Net Amount</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ ratecard.rc_net_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </div>
          </div>
          <div class="col-12 py-2">
            <div class="row">
              <!-- IMAGE DIMENSION -->
              <div class="col-md-2">
                <div class="d-flex align-items-center font-weight-bold">
                  <div>{{ ('Charge Type') }}</div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-5">
                    <div class="d-flex justify-content-center align-items-center font-weight-bold">
                      <div>{{ ('Charge') }}{{ }}</div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex justify-content-center align-items-center font-weight-bold">
                      <div>{{ ('Amount')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom"
            v-for="(cinemaCharge, cinemaChargesIndex) in cinemaChargesList"
            :key="cinemaChargesIndex"
          >
            <div class="row py-2">
              <!-- IMAGE DIMENSION -->
              <div class="col-md-2 mb-2">
                <div class="d-flex align-items-center">
                  <div>{{ cinemaCharge.ct_name }}</div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-5">
                    <div class="d-flex justify-content-center align-items-center">
                      <div>{{ cinemaCharge.pas_charge_value }}{{ cinemaCharge.pas_is_percentage == 'Y' ? '%': ''}}</div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex justify-content-center align-items-center">
                      <div>{{ cinemaCharge.pas_is_rebate === "Y" ? '-'+cinemaCharge.rcs_amount.toFixed(this.MIN_FRACTION_DIGITS) : cinemaCharge.rcs_amount.toFixed(this.MIN_FRACTION_DIGITS)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">Total</div>
              <div class="col-md-3 col-lg-2 col-xl-2">{{ ratecard.rc_total_amount }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                class="col-md-3 col-lg-2 col-xl-2 font-weight-bold"
              >{{ $t('fnbitem') }} {{ $t('name') }}</div>
              <div class="col-md-3 col-lg-2 col-xl-2">{{ selectedItem }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                class="col-md-3 col-lg-2 col-xl-2 font-weight-bold"
              >{{ $t('item') }} {{ $t('compulosry') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ ratecard.item_is_compulsory && ratecard.item_is_compulsory == 'Y' ? 'Active': 'Deactive' }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">{{ $tc('status', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ ratecard.rc_is_active && ratecard.rc_is_active == 'Y' ? 'Active': 'Deactive' }}</div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ ratecard.created_by || '' }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ ratecard.created_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ ratecard.updated_by || '' }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2 font-weight-bold">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ ratecard.updated_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      login_user_role_id: null,
      //Saif
      cinemaChargesList: [],
      cinemaList: [],
      selectedCinema: "Selected Cinema",
      ratecard: {
        rc_id: null,
        cinema_id: null,
        rc_name: "",
        rc_net_amount: 0,
        rc_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        item_id: null,
        item_is_compulsory: false,
        rc_is_active: null,
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",
      },
      selectedItem: "",
      tableId: null,
      // Saif
      imageSettingList: [],
      imageSettingList1: [],
      fnbItems: [],
      status: true,
      recipeList: [
        {
          name: "Popcorn",
          qty: "50 gms",
        },
        {
          name: "Salt",
          qty: "2 gms",
        },
        {
          name: "Oil",
          qty: "2 gms",
        },
      ],
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getEditRatecardList(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    // Saif
    goToRoute: function (path, { rc_id }) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    resetForm: function () {
      this.selectedCinema = "Selected Cinema";
      this.ratecard = {
        rc_id: null,
        cinema_id: null,
        rc_name: "",
        rc_amount: 0,
        rc_total_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",
      };
      this.cinemaChargesList = [];
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.ratecard.cinema_id = item.cine_id;
      this.getCinemaCharges(item.cine_id);
    },
    OnSwitchHandler: function (event) {
      this.ratecard.rc_is_active_inclusivtax = event;
      this.cinemaChargesCalculation();
    },
    onChangeRatecardAmount: function (event) {
      this.cinemaChargesCalculation();
    },
    cinemaChargesCalculation: function () {
      this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_amount);
      this.cinemaChargesList.map((x) => {
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
          // console.log("x.cinemacharges :", x.cinemacharges);
          this.ratecard.rc_total_amount += parseFloat(x.cinemacharges);
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
          // console.log("inclusivoftax x.cinemacharges :", x.cinemacharges);
        }
        return x;
      });
      this.$forceUpdate();
    },
    getEditRatecardList: function (rc_id) {
      CinemasService.GetRatecardById({ rc_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            Object.keys(this.ratecard).map((x) => {
              this.ratecard[x] = obj[x] || this.ratecard[x];
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by", "ratecard");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by", "ratecard");
              }
            });
            this.cinemaChargesList = data.Records[0].chargesList || [];
            this.getFnBItems(data.Records[0].item_id);

            this.getCinemaList(data.Records[0].cinema_id);
            this.ratecard.currency_id = data.Records[0].curr_id;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaList: function (cinema_id) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_cinemas",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaList.map((x) => {
              if (String(cinema_id) == String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.getCinemaCharges(x.cine_id);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFnBItems: function (item_id) {
      let body = {
        tableName: "fnb_items",
        item_id: item_id,
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.fnbItems = data.Records;
              this.fnbItems.map((x) => {
                if (x.item_id == item_id) {
                  this.selectedItem = x.item_name;
                }
              });
            }
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    getCinemaCharges: function (id) {
      // this.cinemaChargesList = [];
      CinemasService.GetCinemaChargesByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // console.log("data.Records :", data.Records);
            // this.cinemaChargesList = data.Records;
            let promises = this.cinemaChargesList.map((x, index) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation();
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },

    // Saif
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/viewRateCard.vue